import { matchPath } from 'react-router-dom';
import { isEmpty } from 'lodash-es';

export const getIsPageCorrect = (pathname, config) => {
  if (!config) {
    return true;
  }

  const REACT_APP_STRICT_ROUTING =
    process.env.REACT_APP_STRICT_ROUTING === 'true';

  const {
    path: cmsPagePath,
    general: { pageConfig: { routes = [] } = {} }
  } = config;

  if (!REACT_APP_STRICT_ROUTING && isEmpty(routes)) {
    return true;
  }

  const cmsPageRootRoute = {
    path: cmsPagePath
  };

  return [cmsPageRootRoute, ...routes].some(
    ({ path: routePath = '', end = true, caseSensitive = false }) =>
      matchPath({ path: routePath, end, caseSensitive }, pathname)
  );
};
